module.exports = __webpack_public_path__ + "static/img/nonelist.a9b72d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nonelist.png
// module id = 6EiN
// module chunks = 1